import HomePageV1, { HomePageV1Props } from './HomePageV1';

const HomePageV2 = ({
  nextDrawDate,
  prizes,
  winners,
  variant,
}: Pick<
  HomePageV1Props,
  'nextDrawDate' | 'prizes' | 'winners' | 'variant'
>) => {
  return (
    <HomePageV1
      withCountdown
      nextDrawDate={nextDrawDate}
      prizes={prizes}
      winners={winners}
      variant={variant}
    />
  );
};

export default HomePageV2;
